export type AccountLogoRemovedPayload = {
	accountId: number;
};

export type AccountLogoRemovedAction = {
	type: 'ACCOUNT_LOGO_REMOVED';
	payload: AccountLogoRemovedPayload;
};

export default (payload: AccountLogoRemovedPayload): AccountLogoRemovedAction => ({
	type: 'ACCOUNT_LOGO_REMOVED',
	payload,
});
